<div class="component d-inline-block"
     mat-ripple
     [style.borderColor]="tag.color"
     [style.color]="selected? 'white': tag.color"
     [style.backgroundColor]="selected ? tag.color : 'inherit'"
     (click)="clicked.emit(tag)">
    {{tag.name}}
</div>
